import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { DashboardDataProvider } from "@/context/DashboardDataContext";
import { PlansFeatureTable } from "@/components/Pricing/PlansFeatureTable";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useAuth } from "@/hooks/useAuth";
import { PublicAuthOverlay } from "@/components/public/PublicAuthOverlay";
import { useTranslation } from "@/context/LanguageContext";

const LimitsContent = () => {
  const { t } = useTranslation();
  return (
    <main className="flex-1 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-5xl py-8 sm:py-12">
        <Link
          to="/pricing"
          className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
        >
          <ChevronLeft className="mr-2 h-4 w-4" />
          {t("limits.back")}
        </Link>
        <h1 className="mb-8 text-center text-xl font-medium sm:mb-12 sm:text-3xl">
          {t("limits.title")}
        </h1>
        <div className="space-y-8">
          <PlansFeatureTable />
          <div className="rounded-3xl border bg-muted/20 p-4 sm:p-6">
            <div className="flex items-start gap-4">
              <div className="flex-1">
                <h3 className="text-base font-medium sm:text-lg">{t("limits.teamsTitle")}</h3>
                <p className="mt-1 text-xs text-muted-foreground sm:text-sm">
                  {t("limits.teamsDesc")}
                </p>
                <Link
                  to="/pricing#teams"
                  className="mt-3 inline-block text-xs font-medium text-primary hover:underline sm:text-sm"
                >
                  {t("limits.teamsLink")}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default function Limits() {
  usePageMeta(
    "Plans & Features — Shattara AI",
    "Compare Free, Pro, and Team plan features and usage limits for Shattara AI."
  );
  const { user, loading } = useAuth();
  const isPublicView = !user;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (isPublicView) {
    return (
      <DashboardShell isPublicView>
        <PublicAuthOverlay />
        <LimitsContent />
      </DashboardShell>
    );
  }

  return (
    <DashboardDataProvider>
      <DashboardShell>
        <LimitsContent />
      </DashboardShell>
    </DashboardDataProvider>
  );
}
